import url from './url';



export default url(({ bonusId = ':bonusId' }) => `/bonuses/${bonusId}/edit`);
